import { Pipe, PipeTransform } from '@angular/core';
import { DPFormField } from 'src/app/core/models/DPFormField';
import { DPFormFieldType } from 'src/app/core/models/enums/DPFormFieldType';

/**
 * Form form field value for different Field types.
 * The transformed string result will be displayed in table columns.
 */
@Pipe({
  name: 'valueFor',
  standalone: true,
})
export class ValueForPipe implements PipeTransform {
  transform(formValue: any, field: DPFormField): unknown {
    if (!formValue || !formValue[field.name]) {
      return '';
    }

    const value = formValue[field.name];
    try {
      if (field.type === DPFormFieldType.Address) {
        const json = JSON.parse(value || '{}');
        const { street, city, state, postalCode } = json;
        return [street, city, state + ' ' + postalCode].join(', ') || '';
      } else if (field.type === DPFormFieldType.YesNo) {
        const json = JSON.parse(value || '{}');
        return json[field.name] || '';
      } else if (
        field.type === DPFormFieldType.Checkbox ||
        field.type === DPFormFieldType.Dropdown ||
        field.type === DPFormFieldType.Radio
      ) {
        const json = JSON.parse(value || '{}');
        return Object.values(json).join(', ');
      }

      return value;
    } catch (err) {
      return '';
    }
  }
}
